class RechageForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    const optionSelectors = this.querySelectorAll('[data-purchase_type]');
    optionSelectors.forEach(option => option.addEventListener('change', this._toggleOptions.bind(this)));
    this.knifesSlider();
    this._toggleOptions('load');
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    
    this.qtyBtns = this.querySelectorAll('[data-qty-btn]');
    this.qtyBtns.forEach(qtyBtn => qtyBtn.addEventListener('click', this.manageQtyBtn.bind(this)));
    
  }
  _toggleOptions(event){
    try {
      let currentTarget = event.currentTarget;
      this.variantsData=JSON.parse(this.form.querySelector('[data-variantJSON]').innerText);
      let type=this.form.querySelector('[name="radios"]:checked')?.getAttribute('data-purchase_type');
      let variantId=JSON.parse(this.form.querySelector('[name="id"]').value);
      let priceEle=this.form.closest('[data-product-container]')?.querySelector('[data-currentprice]');
      let perKnifeELe=this.form.closest('[data-product-container]')?.querySelector('[data-preKnife]');
      let currentVarinat=this.variantsData.find(item=>item.id == variantId);
      if (this.form.querySelector('[data-purchase_type="subscription"]:checked')) {
        var sellingPlanId=this.form.querySelector('[data-purchase_type="subscription"]:checked').value;
      }
      let perKnifePrice='';
      
      
      if (type == 'onetime') {
        priceEle.innerHTML=Shopify.formatMoney(currentVarinat.price,window.globalVariables.money_format);
        perKnifePrice=currentVarinat.price/currentVarinat.option1;
        perKnifeELe.innerHTML=`${Shopify.formatMoney(perKnifePrice,window.globalVariables.money_format)} / Knife`
        
      }else if(sellingPlanId != ""){
        let sellingPlanPrice=currentVarinat.selling_plan_allocations.find(plan => plan.selling_plan_id == sellingPlanId);
        perKnifePrice=sellingPlanPrice.price/currentVarinat.option1;
        priceEle.innerHTML=Shopify.formatMoney(sellingPlanPrice.price,window.globalVariables.money_format);
        perKnifeELe.innerHTML=`${Shopify.formatMoney(perKnifePrice,window.globalVariables.money_format)} / Knife`
      }
    } catch (error) {
      console.error(`File: recharge-product-form.js, getting error on _toggleOptions: ${error}`);
    }
  }
  
  manageQtyBtn(event) {
    try {
      event.preventDefault();
      let currentTarget = event.currentTarget;
      let action = currentTarget.dataset.for || 'increase';
      let $qtyInput = currentTarget.closest('[data-qty-container]').querySelector('[data-qty-input]');
      let currentQty = parseInt($qtyInput.value);
      let finalQty = 1;
      let decreaseQtyBtn = currentTarget.closest('[data-qty-container]').querySelector('[data-for="decrease"]');
      
      if(action == 'decrease' && currentQty < 0){
        if(decreaseQtyBtn) decreaseQtyBtn.classList.add('disabled');
        return false;
      }else if(action == 'decrease'){
        finalQty = currentQty - 1;
        finalQty == 0 ? decreaseQtyBtn.classList.add('disabled') : decreaseQtyBtn.classList.remove('disabled');
      }else{
        if(decreaseQtyBtn) decreaseQtyBtn.classList.remove('disabled');
        finalQty = currentQty + 1;
      }
      
      $qtyInput.value = finalQty;
    } catch (error) {
      Rollbar.error(`File: recharge-product-form.js, getting error on manageQtyBtn: ${error}`);
    }
  }
  
  onSubmitHandler(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    evt.stopImmediatePropagation();
    
    let custom_recharge_product_widget_section = document.querySelector(".custom-recharge-product-widget-section #addtocart");
    
    if(custom_recharge_product_widget_section) {
      gtag('event', 'custom_add_to_cart');
    }
    
    let type=this.form.querySelector('[name="radios"]:checked')?.getAttribute('data-purchase_type');
    const addItems = [];
    const submitButton = this.querySelector('[type="submit"]');
    const qtyInput = this.querySelector('[data-qty-input]');
    const pdpContainer = this.closest('.product-details-wrapper');
    let product_id = this.form.querySelector('input[name="id"]').value;
    if (this.form.querySelector('[data-purchase_type="subscription"]:checked')) {
      var sellingPlanId=this.form.querySelector('[data-purchase_type="subscription"]:checked').value;
    }
    
    let getAllInputs = this.form.querySelectorAll('[data-varid]');
    var getAllAddonVarId = [];
    if (typeof(getAllInputs) != 'undefined' && getAllInputs != null){
      getAllInputs.forEach(element => {
        if(Number(element.value) > 0){
          getAllAddonVarId.push({id: element.getAttribute('data-varid'), quantity: element.value, properties: {_addOn: true, _parentProId: product_id}});
        }
      });
    }
    
    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('loading');
    
    // addItems.push(JSON.parse(serializeForm(this.form)));
    let flag='';
    if (type == 'onetime') {
      flag={
        id:product_id,
        quantity:1
      }
    }else if(sellingPlanId != ""){
      flag={
        id:product_id,
        quantity:1,
        selling_plan:sellingPlanId,
        properties: {
          '_subscription': 'subscription_Product'
        }
      }
    }
    addItems.push(flag);
    if(pdpContainer){
      let addOnItemsEle = pdpContainer.querySelectorAll('[data-addon-selection]:checked');
      addOnItemsEle.forEach((addOn)=>{
        if(!addOn.disabled){
          let addOnParent = addOn.closest('addons-form');
          let addOnJSON = {
            id: addOnParent.querySelector('.variant--id').value,
            quantity: addOnParent.querySelector('.product-quantity').value
          }
          addItems.push(addOnJSON);
        }
      });
    }
    
    const body = JSON.stringify({
      items: addItems
    });
    console.log(body);
    fetch(`${routes.cart_add_url}`, { ...fetchConfig(), body })
      .then((response) => response.json())
      .then(() => {
        if(getAllAddonVarId.length > 0){
          var addOnbody = { items: getAllAddonVarId };
          const result = fetch("/cart/add.json", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "Accept": "application/json"
            },
            body: JSON.stringify(addOnbody)
          }).then(response => {
            window.location.href=`/cart`;
          });
        }else{
          window.location.href=`/cart`;
        }
        
        // this.cartElement.getCartData('open_drawer');
        if(qtyInput) qtyInput.value = 1;
      })
      .catch((e) => {
        console.error(e);
        Rollbar.critical(`File: recharge-product-form.js, getting error on onSubmitHandler: ${e}`);
      })
      .finally(() => {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('disabled');
      });
  }
  knifesSlider(){
    try {
      this.valuesSliders = document.querySelectorAll('.knife_slider');
      if (this.valuesSliders) {
        this.valuesSliders.forEach((valuesSlider) => {
          let valuesForSlider = [4, 5, 7, 10, 14]; // 4 values
          
          let format = {
            to: function(value) {
              return valuesForSlider[Math.round(value)];
            },
            from: function (value) {
              return valuesForSlider.indexOf(Number(value));
            }
          };
          setTimeout(() => {
            noUiSlider.create(valuesSlider, {
              start: 7,
              behaviour: 'smooth-steps-tap',
              range: { min: 0, max: valuesForSlider.length - 1 },
              // steps of 1
              step: 1,
              connect: true,
              tooltips: true,
              format: format,
              pips: { mode: 'steps', format: format },
            });
            
            // The display values can be used to control the slider
            valuesSlider.noUiSlider.set(['7']);
            this.values(valuesSlider);
            
            
            
            valuesSlider.noUiSlider.on('update', (values) => {
              let noUiValues = valuesSlider.querySelectorAll('.noUi-value'),
                knifeSliderValue = document.querySelector('.knife-slider__value');
              
              if(knifeSliderValue) {
                knifeSliderValue.innerHTML = values[0];
              }
              this.querySelector(`variant-radios input[data-handle="${values[0]}"]`).click();
              this._toggleOptions('load');
              noUiValues.forEach(noUiValue => {
                noUiValue.classList.remove('active')
                
                if(noUiValue.innerText == values[0]) {
                  noUiValue.classList.add('active')
                }
              })
            });
            document.querySelector('.noUi-handle').setAttribute('aria-label', 'noUi-Slider');
          }, 3000);
          
        });
      }
    } catch (error) {
      Rollbar.error(`File: recharge-product-form.js, getting error on knifesSlider: ${error}`);
    }
  }
  UpdateValuesSlider(valuesSlider,values){
    let noUiValues = valuesSlider.querySelectorAll('.noUi-value'),
      knifeSliderValue = document.querySelector('.knife-slider__value');
    
    if(knifeSliderValue) {
      console.log(values);
      knifeSliderValue.innerHTML = values[0];
    }
    
    noUiValues.forEach(noUiValue => {
      noUiValue.classList.remove('active')
      console.log(values);
      if(noUiValue.innerText == values[0]) {
        noUiValue.classList.add('active')
      }
    })
  }
  values(valuesSlider){
    let noUiValues = valuesSlider.querySelectorAll('.noUi-value');
    
    noUiValues.forEach(noUiValue => {
      noUiValue.classList.remove('active')
      
      if(noUiValue.innerText == 7) {
        noUiValue.classList.add('active')
      }
      
      noUiValue.addEventListener('click', () => {
        noUiValues.forEach( (noUiElement) => {
          noUiElement.classList.remove('active')
        });
        
        noUiValue.classList.add('active')
        valuesSlider.noUiSlider.set([`${Number(noUiValue.innerHTML)}`])
      })
    })
  }
}
customElements.define('rechage-form', RechageForm);
